import { Link } from 'react-router';
import TrackEventLink from '../track-event-link/TrackEventLink';

const LinkBase = ({ ...restProps }) => {
    if (restProps.disabled) {
        return <a className={restProps.className}>{restProps.children}</a>;
    }
    if (restProps.category) {
        return <TrackEventLink {...restProps} />;
    }
    if (restProps.to?.startsWith('http')) {
        return (
            <a className={restProps.className} rel="noopener noreferrer" href={restProps.to} {...restProps}>
                {restProps.children}
            </a>
        );
    }

    if (!restProps.to) {
        return (
            <a rel="noopener noreferrer" {...restProps}>
                {restProps.children}
            </a>
        );
    }

    return <Link {...restProps} />;
};

export default LinkBase;
